import React, { useEffect } from 'react'
import http from './../../Service/http'
import { direction } from './../../store/direction'

function AdditionDop() {
	const getDops = async () => {
		const dops = await http.post('/addition/oknoSel')
		direction.newDops(dops.data.Okno_dopolnitelno)
	}
	useEffect(() => {
		getDops()
	}, [])

	useEffect(() => {}, [])

	return <></>
}

export default AdditionDop
